import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const CommercialLawPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500 rounded-lg">
              <i className="ri-heart-pulse-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">Liver Health Check</span>
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8">特定商取引法に基づく表記</h1>

          <div className="bg-white rounded-2xl p-8 shadow-lg space-y-6">
            <div className="p-5 bg-blue-50 rounded-lg border border-blue-200 mb-8">
              <p className="text-sm text-gray-700 leading-relaxed">
                現在、本サービスは無料でご利用いただけます。将来的に有料サービスを提供する際は、以下の情報に基づいて運営いたします。
              </p>
            </div>

            <div className="space-y-4">
              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">事業者名</h3>
                <p className="text-sm text-gray-700">MKメディカルパートナーズ</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">事業形態</h3>
                <p className="text-sm text-gray-700">個人事業主</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">所在地</h3>
                <p className="text-sm text-gray-700">請求があった場合に開示いたします</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">お問い合わせ先</h3>
                <p className="text-sm text-gray-700 mb-2">本サービス内のお問い合わせフォームよりご連絡ください</p>
                <a
                  href="/contact"
                  className="text-sm text-blue-600 hover:text-blue-700 transition-colors cursor-pointer"
                >
                  お問い合わせフォームへ →
                </a>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">販売価格</h3>
                <p className="text-sm text-gray-700">各サービスページに表示される価格（税込）</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">支払方法</h3>
                <p className="text-sm text-gray-700">クレジットカード（Stripe決済）</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">支払時期</h3>
                <p className="text-sm text-gray-700">サービス購入時に即時決済</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">サービスの提供時期</h3>
                <p className="text-sm text-gray-700">決済完了後、即時利用可能</p>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">返品・返金について</h3>
                <div className="space-y-2 text-sm text-gray-700">
                  <p>デジタルコンテンツの性質上、原則として返品・返金はお受けできません。</p>
                  <p>ただし、以下の場合は返金対応を検討いたします。</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>システムの不具合によりサービスが利用できない場合</li>
                    <li>二重決済が発生した場合</li>
                  </ul>
                  <p className="mt-2">返金をご希望の場合は、お問い合わせフォームよりご連絡ください。</p>
                </div>
              </div>

              <div className="pb-4 border-b border-gray-200">
                <h3 className="text-sm font-bold text-gray-900 mb-2">サブスクリプションについて</h3>
                <div className="space-y-2 text-sm text-gray-700">
                  <p>サブスクリプションサービスの場合：</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>自動更新となります</li>
                    <li>解約はいつでも可能です</li>
                    <li>解約後、次回更新日までサービスをご利用いただけます</li>
                    <li>日割り返金は行っておりません</li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <h3 className="text-sm font-bold text-gray-900 mb-2">その他</h3>
                <p className="text-sm text-gray-700">
                  本サービスは医療行為・診断・治療を行うものではありません。健康情報の提供を目的としています。
                </p>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">制定日：2026年1月1日</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
            >
              ← トップページへ戻る
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CommercialLawPage;
